import {
  AgentChatEvents,
  LiveChatClient,
  UserChatEvents,
} from '@leagueplatform/live-chat-contract';

export const liveChatClient: LiveChatClient = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  subscribeToAgentChatEvents: (_handler: (event: AgentChatEvents) => void) => {
    // listen for agent events from chosen chat service and send to League's Live Chat SDK
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleUserChatEvents: (_event: UserChatEvents) => {
    // send user chat events to chosen chat service
  },
};
